import { createContext, useContext } from 'react';
import type { RateCode } from './rateControllerModel';

export type RateControllerValue = {
  controlled: RateCode[];
  isControlled: (code: RateCode) => boolean;
  toggle: (code: RateCode) => void;
  setRateStructure: (useBlended: boolean | undefined) => void;
  setBlendedRate: (value: string | number) => void;
  warnings: string[];
};

const noop = () => undefined;

const RateControllerContext = createContext<RateControllerValue>({
  controlled: [],
  isControlled: () => false,
  toggle: noop,
  setRateStructure: noop,
  setBlendedRate: noop,
  warnings: [],
});

export const RateControllerProvider = RateControllerContext.Provider;

export const useRateControllerContext = (): RateControllerValue =>
  useContext(RateControllerContext);
